var render, staticRenderFns
import script from "./LocationHistoryMarker.vue?vue&type=script&lang=js&"
export * from "./LocationHistoryMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e12fc552')) {
      api.createRecord('e12fc552', component.options)
    } else {
      api.reload('e12fc552', component.options)
    }
    
  }
}
component.options.__file = "src/pages/Map/components/LocationHistoryMarker.vue"
export default component.exports